GP.GPMod('FriendPane',function(self) {
    var vent  = null;
    var _util = null;
    var _log  = null;

    var _data = {
        // check and initialize a few params
        init: function() {
            vent   = self.vent;
            _util = self.app.Util;
            _log   = self.app.Util.log;

            _data.friends = new self.app.collections.Friends();
        },
        // local collection of users
        friends:         null,
        curr_page:       1,
        total_pages:     1,
        request_count:   0,
        private_request_count:   0,
        fetching_page:   false,
        previous_action: null,
        undo_timout:     2000, // setTimout interval to undo a declined friend request
        undo_timer:      'friend_pane_undo:', // base for timer name for undo friend request
        matches_selected_by_user: false,
        moshpit_states:  [
            'friend-pane-buddy',
            'friend-pane-matches',
            'friend-pane-approved',
            'friend-pane-favorites',
            'friend-pane-request',
            'friend-pane-pending',
            'friend-pane-blocked',
            'friend-pane-unlocked-content',
            'friend-pane-private',
            'friend-pane-private-request',
            'friend-pane-viewed',
            'friend-pane-unlocked'
        ]
    };

    var gui = {
        init: function() {
            // join moshpit for tracking
            MoshPit.join(self.$el);

            this.$content           = self.$el.find('.pane-content');
            this.$friend_results    = $('#friend-results');
            this.$unlocked_all      = $('#unlocked-all');
            this.$friend_filters    = self.$el.find('#friend-filters');
            this.$friend_requests   = self.$el.find('#friend-requests');
            this.$private_requests  = self.$el.find('#private-requests');
            this.$mass_action_btns  = self.$el.find('#mass-action button');
            this.$fr_link_count     = $('#friend-requests .count-fr');
            this.$pr_link_count     = $('#private-requests .count-pr');
            this.$fr_link           = $('#friend-requests');
            this.$pr_link           = $('#private-requests');
            this.$nav_count         = $('.nav-friends-count');
            this.$nav_count_mobile  = $('.nav-friends-count-mobile');
            this.$count_separator   = $('#count-separator');
            this.$footer            = self.$el.find('.pane-footer');
            this.$pagination_first  = self.$el.find('.pagination .first');
            this.$pagination_prev   = self.$el.find('.pagination .prev');
            this.$pagination_next   = self.$el.find('.pagination .next');
            this.$pagination_count  = self.$el.find('.pagination .page-count .count');
            this.$nano_scroller     = self.$el.find(".nano");
            this.$unlocked_profiles = $('#select-box-unlocked');

            // hide unlocked users
            if (GP.sdata.my_user.membership !== 'BRONZE' || GP.sdata.my_user.native_app_reg) {
                this.$unlocked_profiles.hide();
            }

            this.FriendsList = new self.app.views.FriendsList({
                el: '#friend-results',
                collection: _data.friends,
                childViewOptions: {
                    event_ns: self.moduleName
                }
            });
            this.FriendsList.render();
        },
        set_content_height: function() {
            // adjust the content height (mobile view only)
            var additional_height = $(window).height() - (gui.$footer.offset().top + gui.$footer.outerHeight());
            gui.$content.css('min-height', (gui.$content.height() + additional_height));
        }
    };

    var apis = {
        get_friends: function(friend_type, page) {
            _data.fetching_page = true;
            gui.$friend_results.hide();
            _util.gui.toggle_loading_spinner(true, self.el);

            var filter = $.trim(String(friend_type).toLowerCase());
            var api_data = {
                ajax_request: true,
                action:       "get_friends",
                filter:       (filter || "approved"),
                page:         page
            };

            self.api.json('network.blackbook_json',{
                data:    api_data,
                success: function(json) {
                    events.get_friends_result(json, filter);
                },
                error:   function(jqXHR, status, error) {
                    _data.fetching_page = false;
                    _util.gui.toggle_loading_spinner(false, self.el);
                }
            });
        },
        respond_friend_request: function(action, user_model) {
            var api_data = {
                ajax_request: true,
                rid:    user_model.get('rid'),
                duid:   user_model.get('duid'),
                action: action,
                previous_action: _data.previous_action
            };

            self.api.json('network.blackbook_json', {
                data: api_data,
                type: "POST",
                success: function(json) {
                    var timer_name = _data.undo_timer + api_data.rid;
                    user_model.set('friendship', api_data.action);

                    if (action != 'undo') {
                        var wait = (action == 'approve') ? 0 : _data.undo_timout;

                        // remove user from collection/view after timeout
                        if (action == 'approve') {
                            _util.timers.set(function() {
                                _data.friends.remove(user_model);

                                if (!_data.friends.where({friendship:"request"}).length) {
                                    apis.get_friends(gui.$friend_filters.val(), _data.curr_page);
                                }
                            }, wait, timer_name);
                        } else {
                            _util.timers.set(function() {
                                user_model.set('dim', true);
                            }, wait);

                            var requests = _data.friends.where({friendship: "request"});
                            if (requests.length === 0) {
                                apis.get_friends(gui.$friend_filters.val(), _data.curr_page);
                            }
                        }
                    }
                }
            });
        },
        mass_action: function(rids, duids, action) {
            var api_data = {
                ajax_request: true,
                duids:  duids,
                rid:    rids,
                action: action,
                filter: $.trim(String(gui.$friend_filters.val()).toLowerCase())
            };
            self.api.json('network.blackbook_json', {
                data: api_data,
                type: "POST",
                success: function(json) {

                    // update the state to remove the mass action button(s)
                    MoshPit.remove_state(self.el + '-mass-action');

                    // loop through duid response and update models
                    if (json.success && json.hasOwnProperty('duids')) {
                        $.each(json.duids,function(i, duid){
                            _data.friends.remove(duid);
                        });

                        // if we removed all the users off the current page, regrab the current page
                        if (_data.friends.length === 0) {
                            apis.get_friends(gui.$friend_filters.val(), _data.curr_page);
                        }
                    }
                    if (json.hasOwnProperty('friend_counts')) {
                        if (json.friend_counts.hasOwnProperty('friend_requests')) {
                            events.update_request_count(json.friend_counts.friend_requests);
                        }
                        if (json.friend_counts.hasOwnProperty('private_requests')) {
                            events.update_private_request_count(json.friend_counts.private_requests);
                        }
                    }
                }
            });
        }
    };

    var events = {
        init: function() {
            this.allowed_actions = ["approve", "decline", "remove", "unblock"];

            // set the select box to request and trigger the change event so it will grab the friend requests
            gui.$friend_requests.on('click', function() {
                gui.$friend_filters.val('request').trigger('change');
            });
            //trigger private
            gui.$private_requests.on('click', function() {
                gui.$friend_filters.val('private-request').trigger('change');
            });

            gui.$friend_filters.on('change',this.change_filter);
            gui.$mass_action_btns.on('click', this.handle_mass_action);
            // gui.$content.on('scroll', this.handle_list_scroll);

            gui.$pagination_first.on('click', this.first_page);
            gui.$pagination_prev.on('click', this.prev_page);
            gui.$pagination_next.on('click', this.next_page);

            vent.on(self.moduleName+":show", this.show);
            vent.on(self.moduleName+":approve",this.approve_friend);
            vent.on(self.moduleName+":decline",this.deny_friend);
            vent.on(self.moduleName+":undo_request",this.undo_request);
            vent.on(self.moduleName+":update_count",this.update_request_count);

            vent.on(self.moduleName+":increment_private_count",this.increment_private_count);
            vent.on(self.moduleName+":decrement_private_count",this.decrement_private_count);

            vent.on(self.moduleName+":clear_states",this.clear_states);
            vent.on(self.moduleName+":add_friend_request",this.add_friend_request);
            vent.on(self.moduleName+":add_friend",this.add_friend);
            vent.on(self.moduleName+":add_match",this.add_match);
            vent.on(self.moduleName+":select_filter",this.select_filter);
            vent.on(self.moduleName+":remove_user",this.remove_user);
            vent.on(self.moduleName+":cleanup",this.cleanup);

            // bind to trigger nanoscroller and scroll to the top
            vent.on('Nanoscroller:friend-pane:setup', function() {
                gui.$nano_scroller.nanoScroller(_util.configs.nanoScroller);
                gui.$nano_scroller.nanoScroller({ scroll: 'top' });
            });


            var _picker_row_size = GP.sdata.is_mobile ? 5 : 10;
            gui.$friend_filters.selectpicker({
                maxOptions: 1,
                size:       'auto',
                dropupAuto: false
            });
            gui.$friend_filters.on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
                gui.$friend_filters.selectpicker('refresh');
              });

            // return the current filter/view
            GP.reqres.setHandler(self.moduleName+':get_current_view',  function() {
                if (gui.$friend_filters && gui.$friend_filters.val()) {
                    return gui.$friend_filters.val().toLowerCase();
                }
                return '';
            });

            this.change_filter(false);
        },
        remove_user: function(duid) {
            if (_util.check_obj(duid)) {
                _data.friends.remove(duid);
            }
        },
        select_filter: function(obj) {
            if (typeof obj != 'undefined') {
                if (_util.check_obj(obj.filter)) {
                    // handle closing/minimizing open message threads if requested
                    if (_util.check_obj(obj.messaging)) {
                        vent.trigger('Page:handle_messaging');
                    }
                    // trigger the change event for the friend_filters select box (handles the fetching etc...)
                    gui.$friend_filters.val(obj.filter).trigger('change', true);
                }
            }
        },
        show: function() {
            // show this pane and setup the nanoscroller once it has been shown
            self.$el.show(400, function(e) {
                // trigger event to whatever module is listening for setting up nanoscroll
                vent.trigger('Nanoscroller:friend-pane:setup');
            });

            if (MoshPit.get_size() == 'mobile') {
                gui.set_content_height();
            }
        },
        // cleanup declined users on hide
        cleanup: function() {
            if (MoshPit.has_state("friend-pane-request")) {
                var declined_users = _data.friends.where({friendship:"decline"});

                if (declined_users.length > 0) {
                    for (var i = 0; i < declined_users.length; i++) {
                        _data.friends.remove(declined_users[i]);
                    }
                }
            }
        },
        update_request_count: function(count) {
            var fr_count = Number(count);
                fr_count = (isNaN(fr_count) || fr_count < 0) ? 0 : fr_count;

            // update our internal count
            _data.request_count = fr_count;

            // update count on friend request link count

            gui.$fr_link_count.text(fr_count);

            if (_data.request_count  < 1) {
                gui.$fr_link.addClass('hidden');
                gui.$count_separator.addClass('hidden');
            } else {
                if (_data.private_request_count < 1) {
                    gui.$count_separator.addClass('hidden');
                } else {
                    gui.$count_separator.removeClass('hidden');
                }
                gui.$fr_link.removeClass('hidden');
            }

            MoshPit.add_state(self.el + '-new-requests');

            // update count in select box option
            $('#select-box-requests').text(js_lang.friend_requests_label + ' (' + _data.request_count + ')');
            events.update_total_count();
        },
        update_private_request_count: function(count) {
            var private_count = Number(count);
                private_count = (isNaN(private_count) || private_count < 0) ? 0 : private_count;

            // update our internal count
            _data.private_request_count = private_count;

            // update count on private request link count
            gui.$pr_link_count.text(private_count);

            if (_data.private_request_count  < 1) {
                gui.$pr_link.addClass('hidden');
                gui.$count_separator.addClass('hidden');
            } else {
                if (_data.request_count < 1) {
                    gui.$count_separator.addClass('hidden');
                } else {
                    gui.$count_separator.removeClass('hidden');
                }
                gui.$pr_link.removeClass('hidden');
            }

            MoshPit.add_state(self.el + '-new-requests');

            // update count in select box option
            $('#select-box-private-request').text(js_lang.private_requests_label + ' (' + _data.private_request_count + ')');
            events.update_total_count();
        },
        update_total_count: function() {
            var total_count = (_data.request_count + _data.private_request_count);

            // update counter div (both in nav and sidebar tab)
            if (total_count > 0) {
                gui.$nav_count.text(total_count).show();
                gui.$nav_count_mobile.text(total_count).show();
            } else {
                gui.$nav_count.text(total_count).hide();
                gui.$nav_count_mobile.text(total_count).hide();
            }
            events.refresh_selectpicker();
        },
        increment_friend_request_count: function() {
            events.update_request_count(_data.request_count + 1);
        },
        decrement_friend_request_count: function() {
            events.update_request_count(_data.request_count - 1);
        },
        increment_private_count: function() {
            events.update_private_request_count(_data.private_request_count + 1);
        },
        decrement_private_count: function() {
            events.update_private_request_count(_data.private_request_count - 1);
        },
        first_page: function() {
            _data.curr_page = 1;
            apis.get_friends(gui.$friend_filters.val(), 1);
        },
        prev_page: function() {
            if (_data.fetching_page === true || (_data.curr_page === 1)) {
                return; // currently fetching a page or no more pages... gtfo.
            }
            _data.curr_page--;
            apis.get_friends(gui.$friend_filters.val(), _data.curr_page);
        },
        next_page: function() {
            if (_data.fetching_page === true || (_data.curr_page >= _data.total_pages)) {
                return; // currently fetching a page or no more pages... gtfo.
            }
            _data.curr_page++;
            apis.get_friends(gui.$friend_filters.val(), _data.curr_page);
        },
        handle_list_scroll: function(evnt) {
            if (_data.fetching_page === true || (_data.curr_page >= _data.total_pages)) {
                return; // currently fetching a page or no more pages... gtfo.
            }

            var scroll_pos = Number($(this).scrollTop()) + Number($(this).innerHeight());
            var scroll_tot = Number($(this).prop('scrollHeight'));

            if (scroll_pos >= (scroll_tot-20)) {
                apis.get_friends(gui.$friend_filters.val());
            }
        },
        handle_mass_action: function(evnt) {
            var action = $(this).data('action');
            var duids  = [];
            var rids   = [];

            self.$el.find('input.mass-action:checked').each(function(index) {
                var $cb  = $(this);
                if ($cb.data('duid')) {
                    duids.push($cb.data('duid'));
                }
                if ($cb.data('rid')) {
                    rids.push($cb.data('rid'));
                }
            });

            if (duids.length > 0) {
                if (events.confirm_action(js_lang.friend_pane_mass_actions[action])) {
                    apis.mass_action(rids, duids, 'mass_'+action);
                }
            }
        },
        change_filter: function(bypass_trigger_check) {
            if (!bypass_trigger_check && window.location.search.indexOf('trigger=friend_requests') > -1) {
                events.select_filter({filter: 'request'});
                return;
            }

            var filter  = gui.$friend_filters.val();
            _data.curr_page = 1;

            events.clear_states();
            MoshPit.add_state(self.el + '-' + filter);

            if (filter == 'matches' && bypass_trigger_check !== false) {
                _data.matches_selected_by_user = true;
            }

            apis.get_friends(filter);
        },
        approve_friend: function(user_model) {
            apis.respond_friend_request('approve',user_model);
            events.decrement_friend_request_count();

            _data.previous_action = 'approve';
        },
        deny_friend: function(user_model) {
            // trigger the timer (if there is one pending) so the next one can be setup
            // _util.timers.trigger('friend_pane_undo');
            apis.respond_friend_request('decline',user_model);

            events.decrement_friend_request_count();
            _data.previous_action = 'decline';
        },
        undo_request: function(user_model) {
            var timer_name = _data.undo_timer + user_model.get('rid');
            events.increment_friend_request_count();
            _util.timers.clear(timer_name);
            apis.respond_friend_request('undo',user_model);
        },
        confirm_action: function(message) {
            return confirm(message);
        },
        clear_states: function() {
            for (var i = 0; i < _data.moshpit_states.length; i++) {
                MoshPit.remove_state(_data.moshpit_states[i]);
            }
        },
        add_friend: function(json) {
            var filter  = gui.$friend_filters.val();

            // add to collection if current filter is approved (i.e. you are looking at the approved friends in friend pane)
            _data.friends.remove(json.user.duid);
            if (filter == "approved" && _util.check_obj(json.user)) {
                json.user.friendship = 'approved';
                _data.friends.add(json.user,{merge:true});
            }
        },
        add_match: function(json) {
            var filter  = gui.$friend_filters.val();

            _data.friends.remove(json.user.duid);
            // add to collection if current filter is active
            if (filter == "matches" && _util.check_obj(json.user)) {
                _data.friends.add(json.user,{merge:true});
            }
        },
        add_friend_request: function(json) {
            var filter  = gui.$friend_filters.val();

            // add to collection if current filter is request (i.e. you are looking at the friend requests in friend pane)
            _data.friends.remove(json.user.duid);
            if (filter == "request" && _util.check_obj(json.user)) {
                json.user.friendship = 'request';
                _data.friends.add(json.user,{merge:true});
            }
            // update friend request count
            events.increment_friend_request_count();
        },
        get_friends_result: function(json, filter) {
            _data.fetching_page = false;
            _util.gui.toggle_loading_spinner(false, self.el);
            gui.$friend_results.show();

            // when we grab new users, the state can't be mass-action, because we replace the users
            // so there can't be any checkboxes checked
            MoshPit.remove_state(self.el + '-mass-action');

            // if this is null or falsy, get us outta here... no data
            if (!json) {
                _data.friends.reset();
                return;
            }

            // make sure we have users to put in our Friends collection
            if (json && json.friends) {
                if (json.friends.length === 0 && filter == 'matches' && _data.curr_page == 1) {
                    if (_data.matches_selected_by_user === false) {
                        events.select_filter({filter: 'buddy'});
                        return;
                    }
                }

                var friends = [];
                // ensure we have a friendship type (approved, favorite, viewed, blocked etc...)
                // and default to "remove" (which will hide from friendpane) if we don't have a type
                var friendship = (json.type || json.search_type || "remove");

                for (var i=0; i < json.friends.length; i++) {
                    if (json.friends[i].hasOwnProperty('duid')) {
                        json.friends[i].friendship = String(friendship).toLowerCase();
                        json.friends[i].duid = Number(json.friends[i].duid);

                        json.friends[i].pic    = _util.strip_http_scheme(json.friends[i].pic);
                        json.friends[i].pg_pic = _util.strip_http_scheme(json.friends[i].pg_pic);

                        friends.push(json.friends[i]);
                    }
                }

                var reset_options = {};
                if (filter == 'viewed') {
                    reset_options = {sort: false};
                }

                _data.friends.reset(friends, reset_options);
            } else {
                _data.friends.reset();
            }

            if (json.hasOwnProperty('unlocked_global') && json.unlocked_global) {
                gui.$unlocked_all.removeClass('hidden');
                gui.$content.css('top', 143);
            } else {
                gui.$unlocked_all.addClass('hidden');
                gui.$content.css('top', 116);
            }

            if (json.hasOwnProperty('friend_counts')) {
                if (json.friend_counts.hasOwnProperty('friend_requests')) {
                    events.update_request_count(json.friend_counts.friend_requests);
                }
                if (json.friend_counts.hasOwnProperty('private_requests')) {
                    events.update_private_request_count(json.friend_counts.private_requests);
                }
            }

            if (json.hasOwnProperty('total_pages')) {
                _data.total_pages = Number(json.total_pages);
            }
            if (json.hasOwnProperty('current_page')) {
                _data.curr_page = Number(json.current_page);
                gui.$pagination_count.html(_data.curr_page);

                if ((json.current_page === json.total_pages) || json.total_results === 0 || !_util.check_obj(json.total_results)) {
                    gui.$pagination_next.addClass('disabled');
                } else {
                    gui.$pagination_next.removeClass('disabled');
                }
                if (json.current_page === 1) {
                    gui.$pagination_prev.addClass('disabled');
                    gui.$pagination_first.addClass('disabled');
                } else {
                    gui.$pagination_prev.removeClass('disabled');
                    gui.$pagination_first.removeClass('disabled');
                }
            }

            if (json.hasOwnProperty('online_count')) {
                var online_count = Number(json.online_count);
                    online_count = (online_count == 'NaN') ? 0 : online_count;

                $('#select-box-buddy').text(js_lang.buddy_label.replace(/%COUNT%/, online_count));
            }

            vent.trigger('Nanoscroller:friend-pane:setup');
        },
        refresh_selectpicker: function() {
            gui.$friend_filters.selectpicker('refresh');
        }
    };

    this.addInitializer(function(){
        self.el  = 'friend-pane';
        self.$el = $('#' + self.el);

        _data.init();
        gui.init();
        events.init();
    });
});
